import React from 'react';
import "./Footer.css"
const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__content">
                <p>&copy; 2023 PropShare by MunjiGang. All rights reserved.</p>
                {/* <ul className="footer__links">
          <li><a href="#">Home</a></li>
          <li><a href="#">About</a></li>
          <li><a href="#">Services</a></li>
          <li><a href="#">Contact</a></li>
        </ul> */}
            </div>
        </footer>
    );
}

export default Footer;